import { render, staticRenderFns } from "./diseaseHistoryInfo.vue?vue&type=template&id=bd99d5b0&scoped=true"
import script from "./diseaseHistoryInfo.vue?vue&type=script&lang=js"
export * from "./diseaseHistoryInfo.vue?vue&type=script&lang=js"
import style0 from "./diseaseHistoryInfo.vue?vue&type=style&index=0&id=bd99d5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd99d5b0",
  null
  
)

export default component.exports